(async () => {
    const {
        loadScript: t,
        loadStyle: i
    } = await import(window.theme.modules.utils);
    var e = await import(window.theme.modules.baseComponent);
    customElements.define("swiper-slide", class extends e.default {
        elements = {
            swiper: "[data-swiper]",
            swiperWrapper: "[data-swiper-wrapper]",
            swiperSlide: "[data-swiper-slide]",
            swiperButtonPrev: "[data-swiper-button-prev]",
            swiperButtonNext: "[data-swiper-button-next]",
        };
        async render() {
            await this._initSwiper();
            this.swiper = new Swiper(this.$swiper, {
                speed: this.hasAttribute("speed") ? this.getAttribute("speed") : 400,
                slidesPerView: this.hasAttribute("slides-per-view") ? this.getAttribute("slides-per-view") : 1,
                spaceBetween: this.hasAttribute("space-between") ? this.getAttribute("space-between") : 10,
                loop: this.hasAttribute("loop") ? this.getAttribute("loop") : false,
                navigation: {
                    nextEl: this.$swiperButtonNext,
                    prevEl: this.$swiperButtonPrev,
                }
            })
        }
        async _initSwiper() {
            await t(window.theme.scripts.Swiper, "swiper"), i(window.theme.styles.Swiper)
        }
    })
})();